import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getCarrierList } from '../../api/production-request-api/index.js';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to fetch the list of carriers from WMS.
 */
export const useCarriers = () => {
  const { apiReady } = useApiReady();

  return useQuery({
    queryKey: [QUERY_KEYS.CARRIERS],
    queryFn: () => getCarrierList(),
    enabled: apiReady,
  });
};
